import React, { useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { recover } from "../store/actions/homeActions";
import { Link } from "react-router-dom";

import { languageService } from "./lang/Lang.js";


function Recovery(props) {
  const { recoverFN, errore, recovered } = props;
  const [username, setusername] = useState(null);


  const handleSubmit = (e) => {
    e.preventDefault();
    recoverFN(
      username,
    );
  };


  return (
    <div className="container" style={{ marginTop: "60px" }}>
      <div className="columns" style={{ margin: 13, background: "white", borderRadius: "3px" }}>
        <div
          className="column"
          style={{
            color: "black",
            padding: "10px !important",
          }}
        >
          <form onSubmit={handleSubmit} style={{}}>
            <div style={{ height: "10px" }}></div>

            <p><b>{languageService.translate('recovery.t1')}:</b></p>
            <div style={{ height: "10px" }}></div>
            <div className="field">
              <p className="control has-icons-left">
                <input
                  required
                  className="input"
                  type="text"
                  placeholder={languageService.translate('recovery.t2')}
                  id="username"
                  name="username"
                  onChange={(v) => {
                    setusername(v.target.value);
                  }}
                  style={{ color: "#4b6385", fontSize: "1.2em" }}
                />
                <span className="icon is-small is-left">
                  <i className="fas fa-user"></i>
                </span>
              </p>
            </div>










            <div className="field">
              <button
                style={{
                  padding: "10px 15px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  border: 0,
                  color: "#fff",
                  background: "#F35875",
                  borderRadius: "3px",
                }}
              >
                {languageService.translate('recovery.t3')}
              </button>
            </div>

            {errore ? <p style={{ color: "red", marginTop: "20px" }}>{languageService.translate("reducer.t1")}</p> : null}
            {recovered ? <p style={{ color: "#09C89D", marginTop: "20px" }}>{languageService.translate('recovery.t4')}</p> : null}




          </form>
          <div style={{ height: "20px" }}></div>

          <p>{languageService.translate('recovery.t5')} <Link to="/login" style={{ color: "#F35875" }}>{languageService.translate('recovery.t6')}</Link>.</p>




        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errore: state.home.errore,
    recovered: state.home.recovered,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    recoverFN: (username) =>
      dispatch(recover(username)),

  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  Recovery
);
